import { useField } from 'formik';
import React from 'react';

const InputTextArea = ({ label, required, disabled, rows = 4, ...props }) => {
  const [field, meta] = useField(props);

  const errorClass =
    'block w-full rounded-xl border-0 py-1.5 shadow-sm text-red-900 ring-1 ring-inset ring-red-300 placeholder:text-red-300 focus:ring-2 focus:ring-inset focus:ring-red-500 text-sm';
  const classInput =
    'block w-full rounded-xl border-0 py-1.5 shadow-sm text-kin-text font-regular ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-main text-sm disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500 disabled:ring-gray-200';

  return (
    <div>
      {/* Label */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-1">
          {label && (
            <label className="block text-sm font-medium leading-6 text-kin-text">{label}</label>
          )}
          {required && (
            <label className="block text-xs font-light leading-6 text-gray-400">(required)</label>
          )}
        </div>
        {props.secondlabel && <div>{props.secondlabel}</div>}
      </div>

      {/* TextArea */}
      <div className="mt-1">
        <textarea
          disabled={disabled}
          rows={rows}
          className={`${meta.error ? errorClass : classInput} ${props.resize ? '' : 'resize-none'}`}
          {...field}
          {...props}
        />
      </div>

      {/* Error Message */}
      {meta.touched && meta.error ? (
        <div className="text-red-600 mt-1 text-sm">{meta.error}</div>
      ) : null}
    </div>
  );
};

export default InputTextArea;
